import {createLazyFileRoute} from '@tanstack/react-router'

import FoodGrubhubPaymentResult from '@/views/FoodGrubhub/FoodGrubhubPayment/FoodGrubhubPaymentResult'

export const Route = createLazyFileRoute('/_food-grubhub/food/payment/success')({
  component: FoodGrubhubPaymentResult,
})
